import { Model } from '../parents/model';

export class OrderCustomerAccountModel extends Model {
  static ATTR_ID = 'id';

  static ATTR_NAME = 'name';

  static ATTR_AMOUNT = 'amount';

  static ATTR_TAX_RATE = 'tax_rate';

  static ATTR_CONVERTED_TAXED_AMOUNT = 'converted_taxed_amount';

  get name() {
    return this.attributes[OrderCustomerAccountModel.ATTR_NAME];
  }

  get amount() {
    return this.attributes[OrderCustomerAccountModel.ATTR_AMOUNT];
  }

  get taxRate() {
    return this.attributes[OrderCustomerAccountModel.ATTR_TAX_RATE];
  }

  get convertedTaxedAmount() {
    return this.attributes[OrderCustomerAccountModel.ATTR_CONVERTED_TAXED_AMOUNT];
  }
}
